<template>
  <div id="client-app">
    <router-view />
    <chat-float v-if="showFloat" :embed-mode="isEmbed" />
  </div>
</template>

<script>
import ChatFloat from '@/components/ChatFloat.vue'

export default {
  name: 'App',
  components: { ChatFloat },
  computed: {
    isEmbed() {
      return this.$route.name === 'Embed'
    },
    showFloat() {
      return ['Home', 'Embed'].includes(this.$route.name)
    }
  }
}
</script>

<style>
#client-app {
  min-height: 100vh;
}
</style>
